import styled from "styled-components";
import { Color, Font, breakpoints, ColorDark } from "@/shared/Constants";

export const Container = styled.div `
  width: 100%;

  .title-bonds {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid ${Color.greySeparator};
    padding: 25px 0px 30px;
    ${breakpoints.darkMode} {
      [data-theme='dark'] & {
      border-bottom:1px solid ${ColorDark.greySeparator};
      }
    }
    ${breakpoints.phone} {
      padding: 12px 0px 15px;
    }

    .detail {
      ${Font.sansBold}
      font-size: 20px;
      line-height: 19px;
      color: ${Color.black000};
      ${breakpoints.darkMode} {
        [data-theme='dark'] & {
        color: ${ColorDark.greySeparator};
        }
      }
    }
    .home {
      ${Font.clarinVarSub2Regular}
      font-size: 36px;
      line-height: 28px;
      color: ${Color.grey};
      ${breakpoints.darkMode} {
        [data-theme='dark'] & {
        color: ${ColorDark.greySeparator};
        }
      }
      ${breakpoints.phone} {
        font-size: 26px;
      }
    }
  }

  .bonds-grid {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    ${breakpoints.darkMode} {
      [data-theme='dark'] & {
      color: ${ColorDark.greySeparator};
      }
    }
    ${breakpoints.phone} {
      flex-direction: column;
    }

    .card {
      width: 33.3%;
      padding: 15px 0px;
      border-bottom: 1px solid ${Color.greySeparator};
      ${breakpoints.darkMode} {
        [data-theme='dark'] & {
        border-bottom: 1px solid ${ColorDark.greySeparator};
        }
      }
      ${breakpoints.phone} {
        width: 100%;
        ${breakpoints.phone} {
          &:last-child {
            border-bottom: none;
          }
        }
      }
      /*&:last-child {
        border-bottom: none;
      }*/
      &:nth-child(3n) {
        .card-content {
          border-right: none;
        }
      }
      &:last-child {
        .card-content {
          border-right: none;
        }
      }

      .card-content {
        border-right: 1px solid ${Color.greySeparator};
        height: 145px;
        gap: 5px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        ${breakpoints.phone} {
          border-right: none;
        }

        h2 {
          ${Font.sansBold}
          font-size: 18px;
          line-height: 24px;
          color: ${Color.black000};
          ${breakpoints.darkMode} {
            [data-theme='dark'] & {
            color: ${ColorDark.textLight};
            }
          }
          
        }

        .bond-info {
          display: flex;
          flex-direction: column;

          p {
            ${Font.sansLight}
            font-size: 35px;
            line-height: 24px;
            color: ${Color.grey};
            ${breakpoints.darkMode} {
              [data-theme='dark'] & {
              color: ${ColorDark.greySeparator};
              }
            }
            @media (min-width: 1025px) and (max-width: 1360px) {
              font-size: 28px;
            }
          }
        }

        .button {
          margin-top: 10px;
          display: flex;
          align-items: center;
          justify-content: center;
          width: 90px;
          height: 39px;
          ${Font.sansRegular}
          font-size: 13px;
          line-height: 20px;
          color: ${Color.black000};
          background-color: ${Color.greyF5F5F5};
          border-radius: 50px;
          ${breakpoints.darkMode} {
            [data-theme='dark'] & {
            color: ${ColorDark.textLight};
            background-color:${ColorDark.darkGrey};
            }
          }
          :hover {
            background-color: ${Color.greySeparator};
            ${breakpoints.darkMode} {
              [data-theme='dark'] & {
              background-color:${ColorDark.grey};
              }
            }
          }
        }
      }
    }
  }

  .last-value {
    margin-top: 5px;
    line-height: 20px;
    text-align: center;
    ${Font.sansRegular}
    font-size: 12px;
    color: ${Color.greyCurrency};
    @media (min-width: 976px) and (max-width: 1360px) {
      line-height: 18px;
      width: 90%;
    }
  }
`;